export const tr = {
    'nav.today': "Bugünün Özeti",
    'nav.calendar': "Talep Takvimi",
    'nav.rates': "Fiyatlar ve Kurallar",
    'nav.automation': "Otomasyon Merkezi",
    'nav.audit': "Denetim Günlüğü",
    'nav.settings': "Ayarlar",
    'sidebar.status': "Bağlı",
    'stat.occupancy': "Doluluk",
    'stat.adr': "ADR (Ort. Günlük Fiyat)",
    'stat.revpar': "RevPAR",
    'stat.revenue': "Tah. Gelir",
    'stat.trend.vsLastWeek': "Geçen Hafta",
    'stat.trend.onPace': "Hedefte",
    'dashboard.actions.title': "Önerilen İşlemler",
    'dashboard.actions.empty': "İşlem bulunamadı.",
    'filter.all': "Tümü",
    'filter.pricing': "Fiyatlandırma",
    'filter.restriction': "Kısıtlamalar",
    'action.approve': "Onayla",
    'action.reject': "Reddet",
    'action.risk.low': "düşük risk",
    'action.risk.medium': "orta risk",
    'action.risk.high': "yüksek risk",
    'action.label.current': "Mevcut",
    'action.label.proposed': "Önerilen",
    'action.metric.impact': "Etki",
    'action.metric.why': "Neden",
    'action.status.executed': "Oto-Yürütülmüş",
    'header.search': "Ara...",
    'header.logout': "Çıkış",
    'auto.level.title': "Otopilot Seviyesi",
    'auto.level.manual': "Manuel",
    'auto.level.manual.desc': "Her öneriyi tek tek onaylarsınız.",
    'auto.level.assisted': "Destekli",
    'auto.level.assisted.desc': "Düşük riski otomatik onayla. Önemli değişiklikleri incele.",
    'auto.level.auto': "Tam Otomatik",
    'auto.level.auto.desc': "Yapay Zeka fiyatları 7/24 sınırlarınız dahilinde yönetir.",
    'auto.level.active': "Aktif",
    'auto.guardrails.title': "Güvenlik Sınırları",
    'auto.guardrails.maxIncrease': "Maks. Günlük Artış",
    'auto.guardrails.maxIncrease.desc': "Fiyat şoklarını önleyin.",
    'auto.guardrails.maxDecrease': "Maks. Günlük Düşüş",
    'auto.guardrails.maxDecrease.desc': "İstenmeyen düşüşleri önleyin.",
    'auto.guardrails.minRate': "Taban Fiyat",
    'auto.guardrails.minRate.desc': "Asla bu fiyatın altına satma (Net).",
    'auto.emergency.title': "Acil Durum Kontrolü",
    'auto.emergency.label': "Acil Durdurma",
    'auto.emergency.desc': "Tüm otomasyonu derhal durdurun.",
    'auto.emergency.btn': "SİSTEMİ DURAKLAT",
    'rates.filter.all': "Tüm Oda Tipleri",
    'rates.filter.next14': "Önümüzdeki 14 Gün",
    'rates.export': "Dışa Aktar",
    'audit.table.time': "Zaman",
    'audit.table.actor': "Kullanıcı",
    'audit.table.category': "Kategori",
    'audit.table.action': "İşlem",
    'audit.table.details': "Detaylar",
    'audit.table.status': "Durum",
    'settings.pms.title': "PMS Bağlantısı",
    'settings.pms.connected': "Bağlı:",
    'settings.pms.disconnect': "Bağlantıyı Kes",
    'settings.account.title': "Hesap",
    'settings.account.role': "Rol",
    'settings.restart': "Kurulumu Yeniden Başlat",
    'onboard.title': "PMS Bağla",
    'onboard.desc': "Envanter senkronizasyonu için PMS'inizi seçin.",
    'onboard.connecting': "Bağlanıyor...",
    'onboard.connect': "Bağlan",
    'onboard.success.title': "Kurulum Tamamlandı!",
    'onboard.success.desc': "**SynthHotel Berlin** şimdi senkronize edildi.",
    'onboard.success.sub': "3 Oda Tipi, 14 Fiyat Planı ve 243 Rezervasyon içe aktarıldı.",
    'onboard.btn.dashboard': "Panele Git",
    'action.dynamic.weekend.title': "Hafta Sonu Fiyatını Artır",
    'action.dynamic.weekend.desc': "Cumartesi doluluk > %75, talep güçlü (24 saatte +12 oda).",
    'action.dynamic.minstay.title': "2 Gece Min. Konaklamayı Etkinleştir",
    'action.dynamic.minstay.desc': "Taylor Swift konseri duyuruldu. 1 gecelik konaklamaları engelleyin.",
    'action.dynamic.distress.title': "Fiyatı Düşür (Düşük Talep)",
    'action.dynamic.distress.desc': "Gelecek Salı doluluk %35. Rakipler €10 indirdi.",
    'action.dynamic.gap.title': "Boşluk Doldur: Girişe Kapalıyı Kaldır",
    'action.dynamic.gap.desc': "Tek gecelik boşluk. Satmak için 'Girişe Kapalı' (CTA) kısıtlamasını kaldır.",
};
